import { ref } from 'vue';
import { defineStore } from 'pinia';
import { ProductComplete } from '@/features/Product/types/models';
import { useProductCompleteStore } from './productComplete';
import { stripParentHandle } from '../services/productIdentityBuilder';

export const useProductPageDetails = defineStore('productPageDetails', () => {
  const productCompleteStore = useProductCompleteStore();
  const { getCompleteProduct } = productCompleteStore;

  const product = ref<ProductComplete>();
  const productVariant = ref<ProductComplete>();

  const setActiveProduct = (handle: string, childSlug: string | null = null) => {
    const loadedProduct = getCompleteProduct('attributes.handle', handle);

    if (!loadedProduct) {
      product.value = undefined;
      productVariant.value = undefined;
      return;
    }

    product.value = loadedProduct;

    const normalizedChildSlug = childSlug ? stripParentHandle(childSlug, handle) : null;

    if (
      normalizedChildSlug &&
      loadedProduct.variantProducts &&
      loadedProduct.variantProducts.length > 0
    ) {
      const matchingVariant = loadedProduct.variantProducts.find((variant) => {
        return stripParentHandle(variant.attributes.handle, handle) === normalizedChildSlug;
      });

      productVariant.value = matchingVariant || loadedProduct.variantProducts[0];
    } else if (loadedProduct.variantProducts && loadedProduct.variantProducts.length > 0) {
      productVariant.value = loadedProduct.variantProducts[0];
    } else {
      productVariant.value = loadedProduct;
    }
  };

  return {
    product,
    productVariant,
    setActiveProduct,
  };
});
